module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Magic-207faa89332c38f0640cbee015159ed18704e85ca364b8bf6cba29004e65896c.svg";